module.exports = __webpack_public_path__ + "static/media/CabinetInterior_Before.2bce9fb4.jpg";